export default __webpack_public_path__ + "static/media/Aldo Cazzullo.72ae4a5a.jpg";